import React from 'react';
import DomainView from './DomainView';

export default function IbamaDomain({ debitos, embargos, regularidade }) {
  const data = {
    ibama_debitos: debitos,
    ibama_embargos: embargos,
    ibama_regularidade: regularidade,
  };

  return <DomainView title="IBAMA" data={data} />;
}
